import React, { useState } from "react";

import {
  addTrdxToMetaMask,
  getTrdxMetaMaskManualImportHint,
} from "../../services/web3/addTrdxToWallet";

import "./add-trdx-metamask.css";

/**
 * Prompts wallet_watchAsset for TRDX display in MetaMask (no transfer or purchase).
 */
const AddTrdxToMetaMaskButton = ({ className = "", variant = "default" }) => {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState({ kind: "", text: "" });
  const [showManual, setShowManual] = useState(false);

  const manual = getTrdxMetaMaskManualImportHint();

  const handleClick = async () => {
    setBusy(true);
    setStatus({ kind: "", text: "" });
    setShowManual(false);
    try {
      await addTrdxToMetaMask();
      setStatus({
        kind: "ok",
        text: "TRDX was added to MetaMask. Your on-chain balance may take a moment to display.",
      });
    } catch (err) {
      if (err?.code === "NO_METAMASK") {
        setStatus({ kind: "info", text: err.message });
        setShowManual(true);
      } else if (err?.code === "USER_REJECTED" || err?.code === "WATCH_ASSET_DECLINED") {
        setStatus({ kind: "info", text: err.message });
      } else {
        setStatus({
          kind: "err",
          text: err?.message || "Could not add TRDX to MetaMask.",
        });
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className={`trdx-metamask-import trdx-metamask-import--${variant}${className ? ` ${className}` : ""}`}
    >
      <button
        type="button"
        className="trdx-metamask-import__btn"
        onClick={handleClick}
        disabled={busy}
      >
        {busy ? "Opening MetaMask…" : "Add TRDX to MetaMask"}
      </button>
      <p className="trdx-metamask-import__hint">
        If TRDX does not appear in MetaMask, import the token to display your balance.
      </p>
      <p className="trdx-metamask-import__hint trdx-metamask-import__hint--muted">
        Display only — does not buy, transfer, or mint TRDX.
      </p>
      {status.text ? (
        <p
          className={`trdx-metamask-import__status trdx-metamask-import__status--${status.kind}`}
          role="status"
        >
          {status.text}
        </p>
      ) : null}
      {showManual ? (
        <div className="trdx-metamask-import__manual" role="note">
          <p className="trdx-metamask-import__manual-title">Manual import</p>
          <ul>
            <li>
              <strong>Network:</strong> {manual.network}
            </li>
            <li>
              <strong>Contract:</strong>{" "}
              <span className="trdx-metamask-import__mono">{manual.contract}</span>
            </li>
            <li>
              <strong>Symbol:</strong> {manual.symbol}
            </li>
            <li>
              <strong>Decimals:</strong> {manual.decimals}
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default AddTrdxToMetaMaskButton;
